import BaseApi from './baseApi';
import ISellsDetailPallets from '../models/ISellsDetailPallets';
import IAuthentication from '../models/IAuthentication';
export default class SellsDetailPalletsApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Sells");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetSellsDetailPallets(sellId: string) : Promise<ISellsDetailPallets[]> {
        let json : string = this.getJsonRead(sellId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var sellsPallets: ISellsDetailPallets[] = [];
            sellsPallets = response.data as ISellsDetailPallets[];
            return sellsPallets;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveSellDetailPallets(sellDetailPallets: ISellsDetailPallets) : Promise<string> {
        const json = this.getJsonSave(sellDetailPallets);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateSellDetailPallets(sellDetailPallets: ISellsDetailPallets) : Promise<boolean> {
        const json = this.getJsonUpdate(sellDetailPallets);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteSellDetailPallets(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteInboundDetailBySellId(sellId: string) : Promise<boolean> {
        const json = this.getJsonDeleteBySellId(sellId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDeleteBySellId(sellId: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "sellsDetailPallets",
            "conditions": [{
                "Item1": "sellsDetailPallets",
                "Item2": "idSell",
                "Item3": "=",
                "Item4": sellId
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "conditions": [{
                "Item1": "sellsDetailPallets",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }],
            "table": "sellsDetailPallets"
        };
        return json;
    }

    private getJsonSave(sellDetailPallets: ISellsDetailPallets) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idSell",
                "Item2": sellDetailPallets.idSell
            }, {
                "Item1": "idInboundDeliveryNoteDetail",
                "Item2": sellDetailPallets.idInboundDeliveryNoteDetail
            }, {
                "Item1": "idPallet",
                "Item2": sellDetailPallets.idPallet
            }, {
                "Item1": "idSellDetail",
                "Item2": sellDetailPallets.idSellDetail
            }, {
                "Item1": "location",
                "Item2": sellDetailPallets.location
            }, {
                "Item1": "totalCases",
                "Item2": sellDetailPallets.totalCases
            }, {
                "Item1": "totalGoods",
                "Item2": sellDetailPallets.totalGoods
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "SellsDetailPallets"
        };
        return json;
    }

    private getJsonUpdate(sellDetailPallets: ISellsDetailPallets) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idSell",
                "Item2": sellDetailPallets.idSell
            }, {
                "Item1": "idInboundDeliveryNoteDetail",
                "Item2": sellDetailPallets.idInboundDeliveryNoteDetail
            }, {
                "Item1": "idPallet",
                "Item2": sellDetailPallets.idPallet
            }, {
                "Item1": "idSellDetail",
                "Item2": sellDetailPallets.idSellDetail
            }, {
                "Item1": "location",
                "Item2": sellDetailPallets.location
            }, {
                "Item1": "totalCases",
                "Item2": sellDetailPallets.totalCases
            }, {
                "Item1": "totalGoods",
                "Item2": sellDetailPallets.totalGoods
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "SellsDetailPallets",
            "keyvalue": sellDetailPallets.id
        };
        return json;
    }

    private getJsonRead(sellId: string) : any {
        const json = {
            "fields": [{
                "Item1": "SellsDetailPallets",
                "Item2": "id"
            }, {
                "Item1": "SellsDetailPallets",
                "Item2": "idSell"
            }, {
                "Item1": "SellsDetailPallets",
                "Item2": "idInboundDeliveryNoteDetail"
            }, {
                "Item1": "SellsDetailPallets",
                "Item2": "idPallet"
            }, {
                "Item1": "SellsDetailPallets",
                "Item2": "idSellDetail"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as palletTypeName"
            }, {
                "Item1": "Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "SellsDetailPallets",
                "Item2": "totalCases"
            }, {
                "Item1": "SellsDetailPallets",
                "Item2": "totalGoods"
            }],
            "tables": [{
                "Item1": "SellsDetailPallets"
            }, {
                "Item1": "SellsDetail"
            }, {
                "Item1": "Goods"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDeliveryNotes"
            }, {
                "Item1": "Warehouses"
            }],
            "conditions": [{
                "Item1": "SellsDetailPallets",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "SellsDetailPallets",
                "Item2": "idSell",
                "Item3": "=",
                "Item4": sellId
            }],
            "joins": [{
                "Item1": "SellsDetailPallets",
                "Item2": "IdSellDetail",
                "Item3": "SellsDetail",
                "Item4": "Id"
            }, {
                "Item1": "SellsDetail",
                "Item2": "IdGood",
                "Item3": "Goods",
                "Item4": "Id"
            }, {
                "Item1": "SellsDetail",
                "Item2": "IdListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "SellsDetailPallets",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDeliveryNote",
                "Item3": "InboundsDeliveryNotes",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotes",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }]
        };
        return json;
    }
}
